import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-patient-chip',
    templateUrl: './patient-chip.component.html',
    styleUrl: './patient-chip.component.scss',
    host: {
        '[class.patient-chip-host--compact]': 'compact',
    },
})
export class PatientChipComponent {
    @Input() label?: string;
    @Input() compact = false;
}
